<template>
    <div class="intent">
        <div style="height:20px"></div>
        <div class="intent-block" v-if="item">
            <div class="order-status">
                <span v-if="item.order.payStatus==0" style="color:greed;">待支付</span>
                <span v-if="item.order.payStatus==1" style="color:greed;">待支付</span>
                <p v-if="item.order.payStatus==1">如已支付，稍后再查看支付状态</p>
                <span v-if="item.order.payStatus==2" style="color:blue;">报名成功</span>
                <span v-if="item.order.payStatus==3" style="color:red;">已退款</span>
                <span v-if="item.order.payStatus==4" style="color:greed;">待确认</span>
                <span v-if="item.order.payStatus==5" style="color:red;">退款中</span>
                <span v-if="item.order.payStatus==6" style="color:red;">退款异常</span>
                <span v-if="item.order.payStatus==7" style="color:red;">退款关闭</span>

                <button type="button" class="button button-primary" v-if="item.order.payStatus==1" @click="pay">
                    <div id="templateBtn"></div>
                </button>
            </div>
            <div class="line"></div>
            <div class="row">
                <div class="left">总费用</div>
                <div class="right">¥{{item.order.realPrice}}</div>
            </div>
            <div class="row">
                <div class="left">报名站点</div>
                <div class="right">{{item.station.name}}</div>
            </div>
            <div class="row">
                <div class="left">报名时间</div>
                <div class="right">{{item.order.payTime?item.order.payTime.substring(0, 16):''}}</div>
            </div>
            <div class="row">
                <div class="left">交易单号</div>
                <div class="right">{{item.order.tradeCode}}</div>
            </div>
            <div class="row">
                <div class="left">商户单号</div>
                <div class="right">{{item.order.orderId}}</div>
            </div>
            <div class="line"></div>
            <div class="row">
                <div class="left">紧急联系人</div>
                <div class="right">{{item.order.urgeUser.username}}</div>
            </div>
            <div class="row">
                <div class="left">手机号码</div>
                <div class="right">{{item.order.urgeUser.mobile}}</div>
            </div>
            <div class="row">
                <div class="left">邮箱</div>
                <div class="right">{{item.order.urgeUser.email}}</div>
            </div>
            <div v-for="(e, index) in item.users" :key="e.id">
                <div class="line"></div>
                <div class="row">第{{convertToChinaNum(index+1)}}人</div>
                <div class="row">
                    <div class="left">姓名</div>
                    <div class="right">{{e.username}}</div>
                </div>
                <div class="row">
                    <div class="left">组别</div>
                    <div class="right">{{e.groupType.typeName}}</div>
                </div>
                <template v-for="fee in e.fees">
                    <div class="row" :key="fee.id">
                        <div class="left">费用</div>
                        <div class="right">{{fee.name}} - ¥{{fee.price}}</div>
                    </div>
                </template>
                <div class="row">
                    <div class="left">生日</div>
                    <div class="right">{{e.birthDay}}</div>
                </div>
                <div class="row">
                    <div class="left">手机</div>
                    <div class="right">{{e.mobile}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { MessageBox, Toast } from "mint-ui"
import wx from "weixin-js-sdk"
export default {
    //获取openId
    data(){
        return {
            code: '',
            openId: '',
            wechatReady: false,
            orderId: '',
            item:'',
            templateList: ""
        }
    },
    mounted(){
        this.orderId = this.$route.query.orderId;
        if(!this.orderId){
            MessageBox.alert("缺少必要参数");
        }
        this.openId = localStorage.getItem("openId");
        this.getWechatSign();
        wx.ready(function(){

        });
        wx.error(function(res){
            console.log(res)
            MessageBox.alert("微信支付初始化失败");
        });

        document.title = "我的报名";
        
    },
    methods:{
        getWechatSign:function(){
            const self = this;
            let url = location.href;
            console.log("url" + url);
            let encodeUrl = encodeURIComponent(url);
            this.$http.get("/bicycle/inter/getWechatSign?url="+encodeUrl).then(function(res){
                if(res.data.status != 200){
                     MessageBox.alert(res.data.errorMsg);
                }else{
                    let e = res.data.data;

                    // if(self.$route.query.code){
                    //     self.code = self.$route.query.code;
                        wx.config({
                            debug: false, // 关闭调试模式
                            appId: e.appId, // 必填，公众号的唯一标识
                            timestamp: e.timestamp, // 必填，生成签名的时间戳
                            nonceStr: e.nonceStr, // 必填，生成签名的随机串
                            signature: e.signature,// 必填，签名
                            jsApiList: [
                                'chooseWXPay','updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline'
                            ], // 必填
                            openTagList: ['wx-open-subscribe']
                        });
                        
                        //获取openId
                        if(!self.openId){
                            self.getOpenId();
                        }else{
                            self.getOrder();
                            self.wechatReady = true;
                        }
                       
                        
                        // history.pushState({}, document.title, url);
                    // }else{
                    //     let currentUrl = location.href;
                    //     let redirectUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +e.appId+ "&redirect_uri="+ encodeURIComponent(currentUrl)+"&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
                    //     window.location.href = redirectUrl;
                    // }
                }
            }).catch(function(error){
                console.log(error)
            });
        },
         getOpenId:function(){
            const self = this;
            self.$http.get("/bicycle/inter/getOpenId?code=" + self.code).then(function(res){
                    if(res.data.status != 200){
                        MessageBox.alert(res.data.errorMsg);
                    }else{
                        self.openId = res.data.data;
                        self.wechatReady = true;
                        self.getOrder();
                    }
                }).catch(function(error){
                    console.log(error)
                });
        },
        createTemplate(){
            let self = this;
            let script1 = document.createElement('script');
            script1.type = "text/wxtag-template";
            script1.slot = "style";
            let style = "<style>"
            style += "#subscribe-btn{display:inline-block;color:white;width:108px;height:40px;font-size:15px;line-height:40px;text-align:center;}";
            style += "</style>"
            script1.innerHTML = style;

            let script2 = document.createElement('script')
            script2.type = "text/wxtag-template"
            script2.innerHTML = '<div id="subscribe-btn">付款</div>';

            let html = document.createElement('wx-open-subscribe');
            html.setAttribute("template", self.templateList);
            html.id = "sub-btn";

            html.appendChild(script1)
            html.appendChild(script2)
            
            let btn = document.getElementById("templateBtn");
            btn.appendChild(html)

            this.watchSub(html);
        },
        watchSub(btn){
            let self = this;
            btn.addEventListener('success', (e)=>{
                console.log("订阅了消息")
                self.pay();
            });
            btn.addEventListener('error', (e)=>{
                console.log("订阅错线作物")
                MessageBox.alert("订阅消息通知出现错误，请重试");
                self.addLog(JSON.stringify(error), "订阅消息出错")
            })
        },
        getOrder:function(){
            const self = this;
            self.$http.get("/bicycle/inter/tradeCode?orderId=" + self.orderId+"&openId="+self.openId).then(function(res){
                    if(res.data.status != 200){
                        MessageBox.alert(res.data.errorMsg);
                    }else{
                        self.item = res.data.data;

                        if(self.item.order.payStatus==1){
                            self.getTemplateList((template)=>{
                                self.templateList = [];
                                if(template && template.length){
                                    for(let i = 0 ; i < template.length; i++){
                                        self.templateList += template[i].priTmplId + ","
                                    }
                                }
                                if(self.templateList.length > 0){
                                    self.templateList = self.templateList.substring(0, self.templateList.length-1)
                                    self.createTemplate();
                                }
                            });
                        }
                    }
                }).catch(function(error){
                    console.log(error)
                });
        },
        pay:function(){
            let self = this;
                this.unifiedOrder(this.orderId).then(data =>{
                                    if(!self.wechatReady){
                                        MessageBox.alert("微信支付初始化失败");
                                    }else{

                                        wx.chooseWXPay({
                                            timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                                            nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
                                            package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                                            signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                                            paySign: data.paySign, // 支付签名
                                            success: function (res) {
                                                // 支付成功后的回调函数
                                                MessageBox.alert("支付成功").then(action => {
                                                    //跳转到订单界面
                                                    location.reload();
                                                });
                                            }
                                        });
                                    }
                                });
        },
        unifiedOrder:function(orderId){
            //统一下单
            const self = this;
            return new Promise((resolve, reject) => {
                self.$http.get("/bicycle/inter/unifiedOrder?orderNo=" + orderId + "&openId=" + self.openId).then(function(res){
                    if(res.data.status != 200){
                        MessageBox.alert(res.data.errorMsg);
                        reject(res.data.errorMsg);
                    }else{
                        resolve(res.data.data);
                    }
                }).catch(function(error){
                    console.log(error)
                });
            })
        },
        convertToChinaNum:function(num) {
            var arr1 = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
            var arr2 = new Array('', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千','万', '十', '百', '千','亿');//可继续追加更高位转换值
            if(!num || isNaN(num)){
                return "零";
            }
            var english = num.toString().split("")
            var result = "";
            for (var i = 0; i < english.length; i++) {
                var des_i = english.length - 1 - i;//倒序排列设值
                result = arr2[i] + result;
                var arr1_index = english[des_i];
                result = arr1[arr1_index] + result;
            }
            //将【零千、零百】换成【零】 【十零】换成【十】
            result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
            //合并中间多个零为一个零
            result = result.replace(/零+/g, '零');
            //将【零亿】换成【亿】【零万】换成【万】
            result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
            //将【亿万】换成【亿】
            result = result.replace(/亿万/g, '亿');
            //移除末尾的零
            result = result.replace(/零+$/, '')
            //将【零一十】换成【零十】
            //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
            //将【一十】换成【十】
            result = result.replace(/^一十/g, '十');
            return result;
        }
    }
}
</script>

<style scoped>
.order-status span{
    font-size: 24px;
}
.row{
    display: flex;
     margin-top: 12px;
}
.row .left{
    text-align: left;
    width: 30%;
    color: gray;
}
.row .right{
    text-align: left;
    width: 70%;
   
}
.line{
    height: 1px;
    background: #eee;
     margin-top: 12px;
}
</style>


// WEBPACK FOOTER //
// src/pages/MobileIntented.vue